import { z } from 'zod'

// ─── Tag Profile (list endpoint) ───

export const TagProfileSchema = z.object({
  id: z.number(),
  name: z.string(),
  predefined: z.boolean().default(false),
  item_count: z.number().default(0),
})

export type TagProfile = z.infer<typeof TagProfileSchema>

// ─── Tag Item (ticker + date membership) ───

/** Manual trade outcome, entered by the user in the tag explorer. */
export const TagOutcomeSchema = z.enum(['win', 'loss', 'breakeven'])
export type TagOutcome = z.infer<typeof TagOutcomeSchema>

export const TagItemSchema = z.object({
  id: z.number(),
  ticker: z.string().nullable(),
  target_date: z.string().nullable(),
  row_order: z.number().nullable(),
  outcome: TagOutcomeSchema.nullable().optional(),
  value: z.number().nullable().optional(),
})

export type TagItem = z.infer<typeof TagItemSchema>

// ─── Tag With Items (/v2/tags/full payload) ───

export const TagWithItemsSchema = z.object({
  id: z.number(),
  name: z.string(),
  predefined: z.boolean().default(false),
  items: z.array(TagItemSchema).default([]),
})

export type TagWithItems = z.infer<typeof TagWithItemsSchema>

// ─── Add/Update Item Response ───

export const TagItemMutationResponseSchema = z.object({
  id: z.number(),
  ticker: z.string().nullable().optional(),
  target_date: z.string().nullable().optional(),
  row_order: z.number().nullable().optional(),
  outcome: TagOutcomeSchema.nullable().optional(),
  value: z.number().nullable().optional(),
})

export type TagItemMutationResponse = z.infer<typeof TagItemMutationResponseSchema>
